
import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import desktopImageWebp from './images/ltc-planning-hero.webp';
import mobileImageWebp from './images/ltc-planning-hero-mobile.webp';
// low res images
import { lowResImageDesktop, lowResImageMobile } from './lowResImages';
// styles
import { HeroSectionStyled } from './styles';

export default () => {
  return (
    <HeroSectionStyled
      sectionId='long-term-care-planning-hero'
      moduleName='hero-module'
      moduleVariation='A'
      productName={<>Long&#45;Term Care Planning</>}
      headingText={<>Let&#39;s plan to take care of your <WidowBlock>loved ones.</WidowBlock></>}
      descriptionText={<>Have the flexibility to choose the care you may need for yourself (or a loved one) while helping to protect all that you&#39;ve worked so hard for.</>}
      ctaPrimary={{
        linkUrl: '/find-a-financial-advisor/',
        buttonText: 'Get insurance',
        ariaLabel: 'Get insurance from a financial professional.',
        children: '',
      }}
      backgroundImageAriaLabel='a father hugs his daughter while smiling on a rocky beachfront'
      backgroundImageDesktop={desktopImageWebp.toString()}
      backgroundImageMobile={mobileImageWebp.toString()}
      backgroundImageDesktopLowRes={lowResImageDesktop}
      backgroundImageMobileLowRes={lowResImageMobile}
      backgroundVariant='lightB'
      themeType='lightTheme'
    />
  );};
